export enum LogicOperator {
  AND = 'AND',
  OR = 'OR'
}

// Mirrors logic.models.django_operator.DjangoOperator (backend/homebase/logic/models/django_operator.py).
export enum DjangoOperator {
  EXACT = 'exact',
  IEXACT = 'iexact',
  CONTAINS = 'contains',
  ICONTAINS = 'icontains',
  IN = 'in',
  GT = 'gt',
  GTE = 'gte',
  LT = 'lt',
  LTE = 'lte',
  STARTSWITH = 'startswith',
  ISTARTSWITH = 'istartswith',
  ENDSWITH = 'endswith',
  IENDSWITH = 'iendswith',
  ISNULL = 'isnull'
}

export const DJANGO_OPERATOR_LABELS: Record<string, string> = {
  [DjangoOperator.EXACT]: 'Is',
  [DjangoOperator.IEXACT]: 'Is (case insensitive)',
  [DjangoOperator.CONTAINS]: 'Contains',
  [DjangoOperator.ICONTAINS]: 'Contains (case insensitive)',
  [DjangoOperator.IN]: 'Is any of',
  [DjangoOperator.GT]: 'Greater than',
  [DjangoOperator.GTE]: 'Greater than or equal to',
  [DjangoOperator.LT]: 'Less than',
  [DjangoOperator.LTE]: 'Less than or equal to',
  [DjangoOperator.STARTSWITH]: 'Starts with',
  [DjangoOperator.ISTARTSWITH]: 'Starts with (case insensitive)',
  [DjangoOperator.ENDSWITH]: 'Ends with',
  [DjangoOperator.IENDSWITH]: 'Ends with (case insensitive)',
  [DjangoOperator.ISNULL]: 'Is empty'
};

export interface FieldOptionChoice {
  value: string;
  label: string;
}

// Mirrors logic.services.field_option.FieldOption -- describes one field a
// LogicApplication's LogicElements can filter on, and everything a frontend needs
// to build a criteria-editing UI for it without hardcoding any of this.
export interface FieldOption {
  field: string;
  label: string;
  operators: string[];
  can_negate: boolean;
  value_choices?: FieldOptionChoice[] | null;
  // When true, value_choices are suggestions rather than an exhaustive allowlist,
  // so the UI should let the user type a custom value in addition to picking one.
  allow_custom_value?: boolean;
}

export interface LogicElement {
  id: string;
  logic_group: string;
  field: string;
  comparison_operator: string;
  value: unknown;
  is_negated: boolean;
}

export interface LogicGroup {
  id: string;
  logic_application?: string;
  logic_group?: string | null;
  logic_operator: LogicOperator;
  subject_id: string;
  logic_elements: LogicElement[];
  logic_groups: LogicGroup[];
}

export interface LogicApplication {
  id: string;
  key: string;
  subject_type: number;
}

export type LogicGroupPayload = {
  logic_application?: string;
  logic_group?: string | null;
  logic_operator?: LogicOperator;
  subject_id?: string;
};

export type LogicElementPayload = {
  logic_group: string;
  field: string;
  comparison_operator: string;
  value?: unknown;
  is_negated?: boolean;
};
